import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Decorate from './Decorate';
import TeaserImage from './TeaserImage';
import TeaserTitle from './TeaserTitle';

import '../../styles.css';

BTeaser.propTypes = {
  title: PropTypes.string,
  target: PropTypes.string,
  text: PropTypes.string,
  image: PropTypes.string,
  className: PropTypes.string, // necessaire pour styled
};

function BTeaser({title,target,text,image,className}) {

  if (title === undefined && target === undefined) {
    return null;
  }

  return (
    <a
      className={className + ' teaser'}
      href={target} target="_blank" rel="noreferrer">
      {!!image ? <TeaserImage src={image} alt={''} /> : null}
      <div className="teaser-texts">
        <TeaserTitle>
          <Decorate label={title} />
        </TeaserTitle>
        {!!text ? <Decorate label={text} /> : null}
      </div>
    </a>
  );
}

const Teaser = styled(BTeaser)`
  text-decoration: none;
  cursor: pointer;
  transition: 0.3s;
  color: #fff;
  display: block;
  background-color: ${({ theme }) => theme.headerBgColor};
  height: 100%;
  .teaser-texts {
    padding: 0.2em 0.5em;
    * {
      text-decoration: none;
    }
  }
  &:hover {
    text-decoration: none;
    cursor: pointer;
    background-color: rgba(255,255,255,0.2);
  }
`;

export default Teaser;
